
import { siteDistributionDTO } from '@/types/store/DTO/siteDistributionDTO';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'AdressesDistribution',
  data() {
    return {
      sites: {} as Array<siteDistributionDTO>,
    };
  },
  methods: {
    siteDistrib() {
      this.$store
        .dispatch('SiteDistribution/getSiteDistribution')
        .then((data: Array<siteDistributionDTO>) => {
          this.sites = data;
        });
    },
  },
  created() {
    this.siteDistrib();
  },
});
